<template>
  <div class="img-row row justify-content-center my-4">
    <div
      v-for="(item, index) in media"
      :key="index"
      class="img-wrapper mx-3 mt-3"
    >
      <ImagePreview
        v-if="item.type === 'image'"
        class="cursor-pointer"
        :src="item.image"
        :media-group="media"
      />
      <VideoPreview
        v-else
        class="video-preview cursor-pointer  h-100 w-100"
        :src="item.video"
        :media-group="media"
      />
    </div>
  </div>
</template>

<script>
import { emptyArray } from '@/utils/factories';

import VideoPreview from '@/components/atoms/VideoPreview';
import ImagePreview from '@/components/common/ImagePreview';

export default {
  name: 'MediaRow',

  components: {
    VideoPreview,
    ImagePreview,
  },

  props: {
    media: {
      type: Array,
      default: emptyArray,
    },
  },
};
</script>

<style lang="scss">
.img-row {
  .img-wrapper {
    width: 92px;
    height: 90px;
    border-radius: 8px;
    overflow: hidden;

    img,
    video {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}

.video-player {
  width: 640px;

  video {
    width: 100%;
    height: 100%;
  }
}
</style>
